import React from 'react';
import styles from './privacy-notice.module.scss'
import {Row, Col} from "react-bootstrap";
import esipDPOlogoA from '../../../assets/e-sip-dpo-logo-a_08102027.png'
import esipDPOlogoB from '../../../assets/e-sip-dpo-logo-b_10102026.png'

const PrivacyNotice = () => {
  return (
    <div className={styles['privacy-notice']}>
      <Row className='dpo-logos'>
        <Col lg={6}>
          <img src={esipDPOlogoA} alt='DPO Logo A' height="500"></img>
        </Col>
        <Col lg={6}>
          <img src={esipDPOlogoB} alt='DPO Logo B' height="500"></img>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Row>
            <Col lg={12}>
              <div className={styles['header']}>
                PRIVACY NOTICE
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <p className={styles['justify']}>
            THIS PRIVACY NOTICE EXPLAINS HOW PDS USES THE PERSONAL DATA COLLECTED THROUGH THE E-SECURITIES
            ISSUE PORTAL (“e-SIP”). <span className={styles['underline']}>PLEASE READ THIS PRIVACY NOTICE CAREFULLY.</span> BY CLICKING “SIGN UP” OR “LOGIN”,
            YOU ACKNOWLEDGE THAT (1) YOU HAVE READ AND UNDERSTOOD THIS PRIVACY NOTICE AND (2) CONSENT TO THE
            COLLECTION, USE, DISCLOSURE, STORAGE, TRANSFER AND/OR PROCESSING OF YOUR PERSONAL DATA BY PDS, FOR THE
            PURPOSE/S STATED IN AND UNDER THE TERMS DESCRIBED BELOW AND IN THE COURSE SUCH PERSONAL DATA IS
            MADE AVAILABLE.
          </p>
          <p className={styles['justify']}>
            The Philippine Dealing & Exchange Corp., Philippine Depository & Trust Corp., and Philippine
            Securities Settlement Corp. (collectively, “PDS”) respect and value your right to privacy. We have
            taken the necessary steps for the protection and security of your personal information in the e-SIP.
            PDS observes continuous compliance with the Data Privacy Act of 2012 (“DPA”), its Implementing Rules
            and Regulations (“IRR”), issuances of the National Privacy Commission (“NPC”), and generally accepted
            global data protection standards.
          </p>
          <p className={styles['justify']}>
            PDS maintains the right to amend and/or modify this Privacy Notice to comply with any future developments
            in data privacy regulations where applicable and to reflect any changes in its policies and/or personal
            data processing activities.
          </p>
          <p className={styles['justify']}>
            <span className={styles['underline']}><i>Collection of Your Personal Information</i></span>
          </p>
          <p className={styles['justify']}>
            PDS collects the following personal information only upon your express consent signified by your registration to the e-SIP:
          </p>
          <ul>
            <li>
              <p className={styles['justify']}>
                <span className={styles['underline']}>For Market Participants (Issuers, Underwriter, Arrangers, Selling Agents or Brokers)</span>
              </p>
              <p className={styles['justify']}>
                PDS collects your personal information (such as but not limited to your name, mailing address, telephone number, and email address), as your institution’s designated user, to create your institution’s profile in the e-SIP and to enable access and electronic submission of documents applicable to your institution’s particular role in the listing of securities in the primary market and for secondary market transactions
              </p>
            </li>
            <li>
              <p className={styles['justify']}>
                <span className={styles['underline']}>For Applicant-Clients (invited by Selling Agents); Buying Clients and Selling Clients (invited by Brokers)</span>
              </p>
              <p className={styles['justify']}>
                Your Selling Agent and Broker collect personal information on the e-SIP that are needed to document your securities transactions and implement your instructions (such as reservations to purchase securities for initial offerings, and instructions to enable secondary market settlement). The information includes, among others, your full legal name (last, first and middle names), permanent address, present mailing address, telephone numbers and fax numbers, email address, date of birth, place of birth, nationality, tax identification number, nature of work, sources of income, tax status, and other government-issued identification information
              </p>
            </li>
          </ul>
          <p className={styles['justify']}>
            <span className={styles['underline']}><i>Processing of Personal Information</i></span>
          </p>
          <p className={styles['justify']}>
            Your personal information shall only be used for the use of the e-SIP to which you consent, subject to and in accordance with this Privacy Notice, the relevant Terms and Conditions governing your and/or your institution’s relationship with us, the DPA and its IRR, the Securities Regulation Code, the Terms of Use of the e-SIP, other governing documents, and such other applicable regulations and other agreements which you may have entered with PDS.
          </p>
          <p className={styles['justify']}>
            All your personal information we collect, including anonymized demographic data, may be combined and processed to improve our products, services, and communications with you.
          </p>
          <p className={styles['justify']}>
            In all instances, PDS ensures that only authorized employees and third party service providers who have undertaken to satisfy our stringent corporate, legal, information security, and data privacy requirements, are allowed to access and process your personal information.
          </p>
          <p className={styles['justify']}>
            We will not sell or share your personal information with any third party. We may disclose your personal information for specified purposes which in all cases are in compliance with or pursuant to PDS’s legal, regulatory, or contractual obligations, as well as to:
          </p>
          <ol className={styles['deci']}>
            <li>
              <p className={styles['justify']}>
                Government regulatory agencies who may require PDS to provide the same in the performance of their official functions and
              </p>
            </li>
            <li>
              <p className={styles['justify']}>
                Third party service providers whom we engaged to perform business operations on our behalf and who need to process your personal information to provide these services (such as document processing or courier services).
              </p>
            </li>
          </ol>
          <p className={styles['justify']}>
            <span className={styles['underline']}><i>Data Management</i></span>
          </p>
          <p className={styles['justify']}>
            Storage - Your personal information provided through the e-SIP shall only be stored in a PDS-managed secure environment. We have established procedures to maintain the security of your personal data and prevent unauthorized access, use, and disclosure. Technology solutions are in place (such as encryption) to enable us to enforce security controls required to protect your personal information.
          </p>
          <p className={styles['justify']}>
            Retention – PDS shall only retain your personal data obtained through the e-SIP for as long as we are either required or permitted to by law or as relevant for the purposes for which it was collected, and necessary: a) for the fulfillment of the declared, specified, and legitimate purposes; b) for the establishment, exercise, or defense of legal claims; or c) for legitimate business purposes including compliance with legal or regulatory requirements.
          </p>
          <p className={styles['justify']}>
            Disposal - PDS will cease to retain your personal data and securely dispose of it or remove the means by which the personal data in the e-SIP can be associated with you as soon as it is reasonable to assume that such retention no longer serves the purposes for which the personal data was collected and is no longer necessary for any legal or business purpose.
          </p>
          <p className={styles['justify']}>
            <span className={styles['underline']}><i>Personal Data Breach Management</i></span>
          </p>
          <p className={styles['justify']}>
            PDS has established its personal data breach handling procedure where any security incidents that may potentially result in a personal data breach shall be immediately addressed and measures taken to mitigate negative consequences to data subjects. In the event that it is established that a personal data breach has occurred, PDS shall notify the NPC, relevant market stakeholders, and affected Customers as prescribed in the regulations.
          </p>
          <p className={styles['justify']}>
            <span className={styles['underline']}><i>Your Rights as Data Subject</i></span>
          </p>
          <p className={styles['justify']}>
            Under the Data Privacy Act of 2012, you have the following rights:
          </p>
          <ol className={styles['alpha']}>
            <li>
              <p className={styles['justify']}>
                <span className={styles['underline']}>Right to be informed</span> – you may request for information as to how your personal data is being processed or have been processed by PDS in the e-SIP including the existence of automated decision-making and profiling systems;
              </p>
            </li>
            <li>
              <p className={styles['justify']}>
                <span className={styles['underline']}>Right to object</span> – you may suspend the processing of your personal information, withhold consent to further processing, and remove your personal information from the e-SIP;
              </p>
            </li>
            <li>
              <p className={styles['justify']}>
                <span className={styles['underline']}>Right to access</span> – you may request for reasonable access to your personal information in the e-SIP, which may include the contents of your processed personal information, the manner of processing, sources where they were obtained, recipients, and reason of disclosure;
              </p>
            </li>
            <li>
              <p className={styles['justify']}>
                <span className={styles['underline']}>Right to rectification</span> – you may dispute inaccuracy or error in your personal information in the e-SIP and request for the correction of the information;
              </p>
            </li>
            <li>
              <p className={styles['justify']}>
                <span className={styles['underline']}>Right to data erasure or blocking</span> – based on proof of the grounds provided in the DPA IRR, you have the right to suspend, withdraw, or order blocking, removal, or destruction of your personal data from the e-SIP;
              </p>
            </li>
            <li>
              <p className={styles['justify']}>
                <span className={styles['underline']}>Right to damages</span> – as data subject, you have the right to be indemnified for any damages sustained due to inaccurate, incomplete, outdated, false, unlawfully obtained, or unauthorized use of personal data taking into account any violation of your rights as data subject;
              </p>
            </li>
            <li>
              <p className={styles['justify']}>
                <span className={styles['underline']}>Right to secure data portability</span> – to the extent applicable, you have the right to obtain from PDS your personal information in an electronic or structured format that is commonly used and that allows for further use; and
              </p>
            </li>
            <li>
              <p className={styles['justify']}>
                <span className={styles['underline']}>Right to file a complaint</span> – you may file your complaints or raise any concerns with the National Privacy Commission through www.privacy.gov.ph.
              </p>
            </li>
          </ol>
          <p className={styles['justify']}>
            <span className={styles['underline']}><i>Data Protection Officer</i></span>
          </p>
          <p className={styles['justify']}>
            You may contact the PDS Data Protection Officer through any of the following email
            addresses: <span className={styles['underline']}>pdtc-dpo@pds.com.ph</span>,{' '}
            <span className={styles['underline']}>pdex-dpo@pds.com.ph</span> or{' '}
            <span className={styles['underline']}>pssc-dpo@pds.com.ph</span>.
          </p>
        </Col>
      </Row>
    </div>
  )
}

export default PrivacyNotice;
